// @ts-nocheck
import { supabase } from '@/integrations/supabase/client';

export const listCatalogAwards = async () => {
  const { data, error } = await supabase.from('awards_catalog').select('*').order('name', { ascending: true });
  if (error) throw error;
  return data || [];
};

export const listMyAwards = async () => {
  const { data: session } = await supabase.auth.getUser();
  const me = session.user?.id;
  if (!me) return [] as any[];
  const { data, error } = await supabase.from('user_awards').select('award_id').eq('user_id', me);
  if (error) throw error;
  return (data || []).map((r: any) => r.award_id);
};

export const setShowcaseAwards = async (awardIds: string[]) => {
  const { data: session } = await supabase.auth.getUser();
  const me = session.user?.id;
  if (!me) throw new Error('Not authenticated');
  // Clear slots 0..2 then set
  await supabase.from('profile_showcase_awards').delete().eq('user_id', me);
  const rows = awardIds.slice(0, 3).map((id, idx) => ({ user_id: me, award_id: id, slot: idx }));
  if (rows.length) await supabase.from('profile_showcase_awards').insert(rows);
};

export const getShowcaseAwards = async () => {
  const { data: session } = await supabase.auth.getUser();
  const me = session.user?.id;
  if (!me) return [] as any[];
  const { data, error } = await supabase.from('profile_showcase_awards').select('*').eq('user_id', me).order('slot', { ascending: true });
  if (error) throw error;
  return data || [];
};


